export default {
  label: {
    notClassifiedLabel: 'Não classificado',
    notClassifiedLabelPlural: 'Não Classificados',
    notShowClassifiedLabel: 'Mostrar não classificados',
    showClassifiedLabel: 'Esconder não classificados',
  },
};
